(function () {
  'use strict';
  if (window.TDFundaNativeCart) return;
  const pieces = ['seat', 'back', 'chaise'];
  const labels = { seat: ['funda de asiento', 'fundas de asiento'], back: ['funda de respaldo', 'fundas de respaldo'], chaise: ['funda chaise longue', 'fundas chaise longue'] };
  const sent = new Set();
  let active = null;
  let pending = null;

  function t(key, fallback) {
    const value = window.FUNDA_DATA && window.FUNDA_DATA.i18n && window.FUNDA_DATA.i18n[key];
    return typeof value === 'string' && value.trim() ? value : fallback;
  }
  function error(code, message, details) {
    return Object.assign(new Error(message), { name: 'TDFundaCartError', code, retryAllowed: false, reviewCart: false }, details || {});
  }
  function enabled() {
    return window.FUNDA_DATA && window.FUNDA_DATA.nativeCart === true && window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string';
  }
  function localPath(value, fallback) {
    try {
      const url = new URL(value || fallback, window.location.origin);
      return url.origin === window.location.origin ? url.pathname + url.search : fallback;
    } catch (_) { return fallback; }
  }
  function routes() {
    const root = localPath(window.Shopify.routes.root, '/').replace(/\/?$/, '/');
    const configured = window.routes || {};
    return { root, add: localPath(configured.cart_add_url, root + 'cart/add.js'), state: root + 'cart.js', cart: localPath(configured.cart_url, root + 'cart') };
  }
  function safeImage(value) {
    if (!String(value || '').trim()) return '';
    try {
      const url = new URL(value || '', window.location.origin);
      return /^https?:$/.test(url.protocol) && (url.origin === window.location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
    } catch (_) { return ''; }
  }
  function normalize(input) {
    if (!input || !Array.isArray(input.rows) || !input.rows.length || input.rows.length > 3) throw error('invalid', t('cart_empty_selection', 'Elige al menos una funda.'));
    const counts = {};
    const totals = { seat: 0, back: 0, chaise: 0 };
    pieces.forEach(piece => {
      const count = Number(input.counts && input.counts[piece] || 0);
      if (!Number.isInteger(count) || count < 0 || count > (piece === 'chaise' ? 4 : 8)) throw error('invalid', t('cart_invalid_quantity', 'Revisa la cantidad de fundas seleccionada.'));
      counts[piece] = count;
    });
    const seen = new Set();
    const rows = input.rows.map(row => {
      const variantId = Number(row.variantId);
      const quantity = Number(row.quantity);
      const packSize = Number(row.packSize || 1);
      if (!pieces.includes(row.piece) || seen.has(row.piece) || !Number.isSafeInteger(variantId) || variantId < 1 || !Number.isInteger(quantity) || quantity < 1 || !Number.isInteger(packSize) || packSize < 1 || row.available === false) throw error('unavailable', t('cart_unavailable_combination', 'Esta combinación no está disponible. Prueba con otro color.'));
      seen.add(row.piece);
      totals[row.piece] += quantity * packSize;
      return { variantId, quantity, packSize, piece: row.piece };
    });
    if (pieces.some(piece => counts[piece] !== totals[piece])) throw error('invalid', t('cart_quantity_mismatch', 'Revisa la cantidad de fundas seleccionada.'));
    const total = Number(input.total);
    if (!Number.isSafeInteger(total) || total < 1 || !/^\d+$/.test(String(input.hostProductId || '')) || !['two', 'three', 'sectional', 'custom'].includes(input.preset) || !String(input.label || '').trim() || !String(input.colorLabel || '').trim()) throw error('invalid', t('cart_invalid_selection', 'No pudimos confirmar esta combinación. Actualiza la página e inténtalo nuevamente.'));
    let nativeBundleVariantId = null;
    if (input.preset === 'three' || input.nativeBundleVariantId) {
      const bundle = (window.FUNDA_DATA.nativeBundles || []).find(candidate => String(candidate.id) === String(input.nativeBundleVariantId));
      const valid = input.preset === 'three' && counts.seat === 3 && counts.back === 3 && counts.chaise === 0 && bundle && bundle.available === true && bundle.colorId === input.colorId && Number(bundle.price) === total && String(input.hostProductId) === String(window.FUNDA_DATA.hostProductId) && rows.length === 2 && rows.every(row => row.quantity === 3 && row.packSize === 1 && String(row.variantId) === String(bundle[row.piece + 'VariantId']));
      if (!valid) throw error('invalid', t('cart_invalid_selection', 'No pudimos confirmar esta combinación. Actualiza la página e inténtalo nuevamente.'));
      nativeBundleVariantId = Number(bundle.id);
      if (!Number.isSafeInteger(nativeBundleVariantId) || nativeBundleVariantId < 1) throw error('invalid', t('cart_invalid_selection', 'No pudimos confirmar esta combinación. Actualiza la página e inténtalo nuevamente.'));
    }
    return { rows, counts, total, nativeBundleVariantId, preset: input.preset, label: String(input.label), colorLabel: String(input.colorLabel), hostProductId: String(input.hostProductId), productUrl: localPath(input.productUrl, window.location.pathname), heroUrl: safeImage(input.heroUrl), eventTarget: input.eventTarget, opener: input.opener || document.activeElement };
  }
  function bundleKey() {
    return 'funda-' + Date.now().toString(36) + '-' + (window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : Math.random().toString(36).slice(2, 12));
  }
  function transaction(input) {
    const key = bundleKey();
    const metadata = {
      _td_bundle_title: 'Funda Mágica Completa', _td_bundle_configuration: input.label, _td_bundle_color: input.colorLabel,
      _td_bundle_seat: String(input.counts.seat), _td_bundle_back: String(input.counts.back), _td_bundle_chaise: String(input.counts.chaise),
      _td_bundle_includes: pieces.filter(piece => input.counts[piece]).map(piece => input.counts[piece] + ' ' + labels[piece][input.counts[piece] === 1 ? 0 : 1]).join(' · '),
      _td_bundle_image: input.heroUrl, _td_bundle_url: input.productUrl
    };
    const items = input.nativeBundleVariantId ? [{ id: input.nativeBundleVariantId, quantity: 1, properties: Object.assign({
      'Configuración': input.label, _td_solution: 'funda_magica_complete', _td_solution_product_id: input.hostProductId, _td_bundle_key: key,
      _td_native_bundle: 'true', _td_color: input.colorLabel
    }, metadata) }] : input.rows.map(row => ({ id: row.variantId, quantity: row.quantity, properties: Object.assign({
      'Configuración': input.label, _td_solution: 'funda_magica_complete', _td_solution_product_id: input.hostProductId, _td_bundle_key: key,
      _td_piece: row.piece, _td_color: input.colorLabel, _td_pack_size: String(row.packSize), _td_units: String(row.packSize * row.quantity)
    }, metadata) }));
    return { input, key, items, routes: routes(), status: 'posting', rejection: null };
  }
  function signature(item) {
    const properties = item.properties || {};
    return [String(item.variant_id || item.id || ''), String(properties._td_piece || ''), String(properties._td_pack_size || '')].join('|');
  }
  function inspect(data, tx) {
    const actual = {};
    const expected = {};
    let found = false;
    let nativeComponentsMatch = !tx.input.nativeBundleVariantId;
    tx.items.forEach(item => { expected[signature(item)] = (expected[signature(item)] || 0) + item.quantity; });
    (data && Array.isArray(data.items) ? data.items : []).forEach(item => {
      if (String(item.properties && item.properties._td_bundle_key || '') !== tx.key) return;
      found = true;
      actual[signature(item)] = (actual[signature(item)] || 0) + Number(item.quantity || 0);
      if (tx.input.nativeBundleVariantId && String(item.variant_id || item.id) === String(tx.input.nativeBundleVariantId)) {
        nativeComponentsMatch = item.has_components === true;
        if (Array.isArray(item.item_components)) {
          const components = item.item_components;
          nativeComponentsMatch = nativeComponentsMatch && components.length === tx.input.rows.length && tx.input.rows.every(row => components.filter(component => String(component.variant_id || component.id) === String(row.variantId)).reduce((sum, component) => sum + Number(component.quantity || 0), 0) === row.quantity);
        }
      }
    });
    const exact = found && nativeComponentsMatch && Object.keys(actual).length === Object.keys(expected).length && Object.keys(expected).every(key => actual[key] === expected[key]);
    return { found, exact };
  }
  function cartUi() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function sectionIds(ui) {
    let list = ['cart-drawer', 'cart-icon-bubble'];
    try { if (ui && typeof ui.getSectionsToRender === 'function') list = ui.getSectionsToRender().map(section => section.id); } catch (_) {}
    return [...new Set(list)].filter(id => typeof id === 'string' && id.length).slice(0, 5);
  }
  function render(data, ui, ids) {
    if (!ui || typeof ui.renderContents !== 'function' || !ids.length || !data.sections || ids.some(id => typeof data.sections[id] !== 'string' || !data.sections[id].trim())) return false;
    const item = data.items && data.items[0];
    if (item) { data.key = data.key || item.key; data.id = data.id || item.id || item.variant_id; }
    try {
      if (ui.classList) ui.classList.remove('is-empty');
      const inner = ui.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      ui.renderContents(data);
      return true;
    } catch (_) { return false; }
  }
  async function readJson(url, options) {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), options && options.method === 'POST' ? 15000 : 8000);
    try {
      const response = await fetch(url, Object.assign({ credentials: 'same-origin', cache: 'no-store', signal: controller.signal }, options));
      let data;
      try { data = await response.json(); } catch (_) { throw error('response', t('cart_invalid_response', 'No pudimos confirmar la respuesta del carrito.')); }
      if (!response.ok || data && Number(data.status) >= 400) {
        const status = Number(data && data.status || response.status);
        const message = data && (data.description || data.message);
        throw error('shopify', typeof message === 'string' && message.trim() ? message : t('cart_add_failed', 'No pudimos agregar esta combinación. Revisa su disponibilidad.'), { httpStatus: status });
      }
      return data;
    } finally {
      window.clearTimeout(timer);
    }
  }
  async function sections(tx, state, ui, ids) {
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('sections', ids.join(','));
    const html = await readJson(url.pathname + url.search, { headers: { Accept: 'application/json' } });
    return render(Object.assign({}, state, { sections: html }), ui, ids);
  }
  function emit(tx) {
    if (sent.has(tx.key)) return;
    sent.add(tx.key);
    const payload = { event: 'td_funda_solution_added', product_id: tx.input.hostProductId, configuration: tx.input.preset, color: tx.input.colorLabel, seat_qty: tx.input.counts.seat, back_qty: tx.input.counts.back, chaise_qty: tx.input.counts.chaise, value: tx.input.total / 100, currency: window.FUNDA_DATA.currency || 'CLP' };
    try {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.dataLayer.push === 'function') window.dataLayer.push(payload);
    } catch (_) {}
    try {
      const target = tx.input.eventTarget && typeof tx.input.eventTarget.dispatchEvent === 'function' ? tx.input.eventTarget : document;
      target.dispatchEvent(new CustomEvent('td:funda-solution-added', { bubbles: true, detail: payload }));
    } catch (_) {}
  }
  async function complete(tx, data, recovered) {
    pending = null;
    tx.status = 'complete';
    emit(tx);
    const ui = cartUi();
    const ids = sectionIds(ui);
    let displayed = render(data, ui, ids);
    if (!displayed && ui) {
      try { displayed = await sections(tx, data, ui, ids); } catch (_) {}
    }
    if (!displayed) window.location.assign(tx.routes.cart);
    return { ok: true, bundleKey: tx.key, recovered, displayed: displayed ? 'drawer' : 'cart-page', cartUrl: tx.routes.cart };
  }
  async function recover(tx) {
    let state;
    try { state = await readJson(tx.routes.state, { headers: { Accept: 'application/json' } }); }
    catch (_) {
      tx.status = 'unconfirmed';
      throw error('unconfirmed', t('cart_unconfirmed_add', 'No pudimos confirmar si se agregaron las fundas. Revisa tu carrito antes de volver a agregar.'), { reviewCart: true, cartUrl: tx.routes.cart, bundleKey: tx.key });
    }
    if (!state || !Array.isArray(state.items)) {
      tx.status = 'unconfirmed';
      throw error('unconfirmed', t('cart_check_failed', 'No pudimos comprobar tu carrito. Revísalo antes de volver a agregar.'), { reviewCart: true, cartUrl: tx.routes.cart, bundleKey: tx.key });
    }
    const result = inspect(state, tx);
    if (result.exact) return complete(tx, state, true);
    if (result.found) {
      tx.status = 'partial';
      throw error('partial', t('cart_partial_add', 'El carrito contiene una cantidad diferente a tu selección. Revísalo antes de agregar más fundas.'), { reviewCart: true, cartUrl: tx.routes.cart, bundleKey: tx.key });
    }
    if (tx.rejection && tx.rejection.httpStatus === 422) {
      pending = null;
      tx.status = 'rejected';
      throw error('unavailable', tx.rejection.message || t('cart_stock_error', 'No hay suficiente stock para esta combinación. Prueba con otra selección.'), { retryAllowed: true, httpStatus: 422 });
    }
    tx.status = 'unconfirmed';
    throw error('unconfirmed', t('cart_unconfirmed_result', 'No pudimos confirmar el resultado. Revisa tu carrito para evitar agregar las fundas dos veces.'), { reviewCart: true, cartUrl: tx.routes.cart, bundleKey: tx.key });
  }
  async function submit(tx) {
    const ui = cartUi();
    const ids = sectionIds(ui);
    if (ui && typeof ui.setActiveElement === 'function') ui.setActiveElement(tx.input.opener);
    let data;
    try {
      data = await readJson(tx.routes.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: tx.items, sections: ids, sections_url: window.location.pathname }) });
    } catch (failure) {
      tx.rejection = failure;
      return recover(tx);
    }
    if (!inspect(data, tx).exact) return recover(tx);
    return complete(tx, data, false);
  }
  function add(input) {
    if (!enabled()) return Promise.reject(error('disabled', t('cart_disabled_add', 'El carrito de compra no está activo en esta vista.')));
    if (active) return active;
    if (!pending) {
      try { pending = transaction(normalize(input)); } catch (failure) { return Promise.reject(failure); }
    }
    const tx = pending;
    active = (tx.status === 'posting' ? submit(tx) : recover(tx)).finally(() => { active = null; });
    return active;
  }
  function reconcile() {
    if (!enabled()) return Promise.reject(error('disabled', t('cart_disabled_reconcile', 'El carrito de compra no está activo en esta vista.')));
    if (active) return active;
    if (!pending) return Promise.resolve({ ok: false, pending: false });
    active = recover(pending).finally(() => { active = null; });
    return active;
  }
  window.TDFundaNativeCart = Object.freeze({
    add, reconcile,
    getStatus: () => ({ enabled: !!enabled(), busy: !!active, pending: !!pending, state: pending ? pending.status : 'idle', cartUrl: enabled() ? routes().cart : null })
  });
})();
